export const DEBOUNCE_DELAY = 500;

export const SUCCESS_MESSAGE_DURATION = 2000;
export const ERROR_MESSAGE_DURATION = 4000;

export enum PatchStatus {
  INITIAL = 'initial',
  SUCCESS = 'success',
  ERROR = 'error',
}
